import merge from 'deepmerge';
import { API_URL, ORIGIN_PATH } from '../../environment';

// Service that enables the application to access originating borrower/loan/property information.
const OriginService = (originId, partnerAccessToken) => {
  const missingText = '';

  // Base loan object
  const _baseLoan = {
    loanNumber: missingText,
  };

  // Base borrower and co-borrower objects
  const _baseApplication = {
    id: missingText,
    birthDate: missingText,
    emailAddressText: missingText,
    firstName: missingText,
    fullNameWithSuffix: missingText,
    homePhoneNumber: missingText,
    lastName: missingText,
    middleName: missingText,
    taxIdentificationIdentifier: missingText,
    borrowerOptions: missingText,
    employment: {
      addressCity: missingText,
      addressPostalCode: missingText,
      addressState: missingText,
      badgeOrEmployeeId: missingText,
      basePayAmount: missingText,
      currentEmploymentIndicator: missingText,
      employerName: missingText,
      employmentStartDate: missingText,
      endDate: missingText,
      id: missingText,
      phoneNumber: missingText,
      positionDescription: missingText,
      urla2020StreetAddress: missingText,
    },
    residences: {
      addressCity: missingText,
      addressPostalCode: missingText,
      addressState: missingText,
      addressStreetLine1: missingText,
      urla2020StreetAddress: missingText,
    },
    auth: {
      token: missingText,
      expiresAt: missingText,
    },
  };

  // Utility function - deep merges loan data with base state
  const _deepMerge = (intermediateData) => {
    const applications = Array.isArray(intermediateData.loan.applications)
      ? intermediateData.loan.applications
      : [_baseApplication];


    // Final loan object
    const finalLoan = merge(_baseLoan, intermediateData.loan);

    // Applications array with separate indexes for borrower and co-borrower
    finalLoan.applications = [];

    // Loop through applications and merge borrower & co-borrower
    applications.forEach((application, index) => {

      if (application.borrower) {
        const borrower = merge(_baseApplication, application.borrower);
        borrower.borrowerOptions = `Borrower Only (URLA -${index + 1})`;
        finalLoan.applications.push(borrower);
      }

      if (application.coborrower) {
        const coborrower = merge(_baseApplication, application.coborrower);
        coborrower.borrowerOptions = `CoBorrower Only (URLA -${index + 1})`;
        finalLoan.applications.push(coborrower);
      }
    });
    finalLoan.auth = merge(_baseLoan.auth, intermediateData.auth);
    // Merge the point of contact information
    finalLoan.pointOfContact = merge(_baseLoan.pointOfContact || {}, intermediateData.pointOfContact || {});

    return finalLoan;
  };

  // Function to fetch origin loan data and merge with base state
  const _getOriginLoanData = async () => {
    // const url = `${API_URL}${ORIGIN_PATH}${originId}?partner_access_token=${partnerAccessToken}`;
    const url = API_URL + ORIGIN_PATH +
      originId + '?partner_access_token=' + partnerAccessToken;
    try {
      const response = await fetch(url);
      // if (!response.ok) {
      //   throw new Error(`HTTP error! Status: ${response.status}`);
      // }

      const intermediateResponse = await response.json();

      if(intermediateResponse.status == true){
        localStorage.setItem('auth', JSON.stringify(intermediateResponse.data.auth)); 
      }
      
      return intermediateResponse;
    } catch (error) {
      console.error(error);
    }
  };

  // Public interface for this service
  return {
    getOriginLoanData: _getOriginLoanData,
    getDeepMerge: _deepMerge,
  };
};

export default OriginService;